import { NbaGame } from './models/game';
import { NbaWeek } from './models/week';
import type { IWeek } from '../shared/interfaces/IWeek';
import type { IGame } from '../shared/interfaces/IGame';
import { Enumerable } from '../shared/linq';

export function GetSchedule(teams: TeamDictionary, games: IGameData[]): WeekDictionary {
  const dict: WeekDictionary = {};
  let week: IWeek;
  const maxWeek = Enumerable.From(games).Max((g: IGameData) => g.Week);

  for (let i = 1; i <= maxWeek; i++) {
    dict[i] = [];
    week = new NbaWeek('Western');
    dict[i].push(week);
    week = new NbaWeek('Eastern vs. Western');
    dict[i].push(week);
    week = new NbaWeek('Eastern');
    dict[i].push(week);
  }

  for (const _gameInt in games) {
    const game: IGameData = games[_gameInt];
    const homeTeam = teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation];
    const awayTeam = teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation];
    const newGame = ko.observable(
      new NbaGame(homeTeam, awayTeam, game.Week, game.GameScheduleNum, 0, game.GameDate, game.GameGUID, game.GameKey)
    ) as unknown as KnockoutObservable<IGame>;

    if (game.Away.Conference === game.Home.Conference) {
      if (game.Away.Conference === 'Western') {
        dict[game.Week][0].games.push(newGame);
      } else {
        dict[game.Week][2].games.push(newGame);
      }
    } else {
      dict[game.Week][1].games.push(newGame);
    }
  }

  // Play-in round 1
  dict[maxWeek + 1] = [];
  dict[maxWeek + 1].push(new NbaWeek('Eastern'));
  dict[maxWeek + 1].push(new NbaWeek('Eastern vs Western'));
  dict[maxWeek + 1].push(new NbaWeek('Western'));

  // Play-in round 2
  dict[maxWeek + 2] = [];
  dict[maxWeek + 2].push(new NbaWeek('Eastern'));
  dict[maxWeek + 2].push(new NbaWeek('Eastern vs Western'));
  dict[maxWeek + 2].push(new NbaWeek('Western'));

  // RD1
  dict[maxWeek + 3] = [];
  dict[maxWeek + 3].push(new NbaWeek('Eastern'));
  dict[maxWeek + 3].push(new NbaWeek('Eastern vs Western'));
  dict[maxWeek + 3].push(new NbaWeek('Western'));

  // RD2 (Conference Semifinals)
  dict[maxWeek + 4] = [];
  dict[maxWeek + 4].push(new NbaWeek('Eastern'));
  dict[maxWeek + 4].push(new NbaWeek('Eastern vs Western'));
  dict[maxWeek + 4].push(new NbaWeek('Western'));

  // Conference Finals
  dict[maxWeek + 5] = [];
  dict[maxWeek + 5].push(new NbaWeek('Eastern'));
  dict[maxWeek + 5].push(new NbaWeek('Eastern vs Western'));
  dict[maxWeek + 5].push(new NbaWeek('Western'));

  // Finals
  dict[maxWeek + 6] = [];
  dict[maxWeek + 6].push(new NbaWeek('Eastern'));
  dict[maxWeek + 6].push(new NbaWeek('Eastern vs Western'));
  dict[maxWeek + 6].push(new NbaWeek('Western'));

  return dict;
}
